import React from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../../store.type';
import ActiveChatCard from '../components/ActiveChatCard';
import { ChatBotWrapperProps } from '../utils';

const ChatBotWrapper = ({
  isHelpCenterUiLoading
}: ChatBotWrapperProps): React.ReactElement<ChatBotWrapperProps> | null => {
  if (isHelpCenterUiLoading) return null;

  return <ActiveChatCard />;
};

function mapStateToProps(state: IStore) {
  const {
    rootReducer: {
      helpCenterReducer: { isHelpCenterUiLoading }
    }
  } = state;
  return { isHelpCenterUiLoading };
}

export default connect<ChatBotWrapperProps, null, null, any>(mapStateToProps)(ChatBotWrapper);
